import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import AppBanners from "@/components/pwa/AppBanners";
import { setupPwa } from "@/pwa";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Installable app: service worker + install / update banners, in their own root so they can never break the app.
setupPwa();
try {
  const el = document.createElement("div");
  el.id = "pwa-root";
  document.body.appendChild(el);
  ReactDOM.createRoot(el).render(<AppBanners />);
} catch { /* the app itself is unaffected */ }
